var _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitleGame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 89,
    viewBox: "0 0 60 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M19.6759 76.588L19.1579 79.01H21.0059V80.41H18.8639L18.3039 83H16.7779L17.3379 80.41H14.5939L14.0339 83H12.5079L13.0679 80.41H10.8979V79.01H13.3619L13.8799 76.588H11.7239V75.188H14.1739L14.7199 72.64H16.2459L15.6999 75.188H18.4439L18.9899 72.64H20.5159L19.9699 75.188H21.8319V76.588H19.6759ZM18.1499 76.588H15.4059L14.8879 79.01H17.6319L18.1499 76.588ZM29.4489 73.27V74.572L25.3189 74.572V77.442H28.5389V78.744H25.3189V83H23.7229V73.27H29.4489ZM32.5239 73.27V83H30.9279V73.27H32.5239ZM40.3453 73.27V74.572H36.2153V77.442H39.4353V78.744H36.2153V83H34.6193V73.27H40.3453ZM47.6904 81.012H43.6164L42.9164 83H41.2504L44.7364 73.256H46.5844L50.0704 83H48.3904L47.6904 81.012ZM47.2424 79.71L45.6604 75.188L44.0644 79.71H47.2424Z",
    fill: "#F4F3FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_419_4072)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 16,
    fill: "#F1CAFF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9415 25.26C19.0082 23.9267 19.4748 22.9 20.3415 22.18C21.2215 21.4467 22.3748 21.08 23.8015 21.08C24.7748 21.08 25.6082 21.2533 26.3015 21.6C26.9948 21.9333 27.5148 22.3933 27.8615 22.98C28.2215 23.5533 28.4015 24.2067 28.4015 24.94C28.4015 25.78 28.1815 26.4933 27.7415 27.08C27.3148 27.6533 26.8015 28.04 26.2015 28.24V28.32C26.9748 28.56 27.5748 28.9867 28.0015 29.6C28.4415 30.2133 28.6615 31 28.6615 31.96C28.6615 32.76 28.4748 33.4733 28.1015 34.1C27.7415 34.7267 27.2015 35.22 26.4815 35.58C25.7748 35.9267 24.9215 36.1 23.9215 36.1C22.4148 36.1 21.1882 35.72 20.2415 34.96C19.2948 34.2 18.7948 33.08 18.7415 31.6H21.4615C21.4882 32.2533 21.7082 32.78 22.1215 33.18C22.5482 33.5667 23.1282 33.76 23.8615 33.76C24.5415 33.76 25.0615 33.5733 25.4215 33.2C25.7948 32.8133 25.9815 32.32 25.9815 31.72C25.9815 30.92 25.7282 30.3467 25.2215 30C24.7148 29.6533 23.9282 29.48 22.8615 29.48H22.2815V27.18H22.8615C24.7548 27.18 25.7015 26.5467 25.7015 25.28C25.7015 24.7067 25.5282 24.26 25.1815 23.94C24.8482 23.62 24.3615 23.46 23.7215 23.46C23.0948 23.46 22.6082 23.6333 22.2615 23.98C21.9282 24.3133 21.7348 24.74 21.6815 25.26H18.9415ZM32.3221 23.384C32.5381 23.032 32.8181 22.756 33.1621 22.556C33.5141 22.356 33.9141 22.256 34.3621 22.256V24.02H33.9181C33.3901 24.02 32.9901 24.144 32.7181 24.392C32.4541 24.64 32.3221 25.072 32.3221 25.688V29H30.6421V22.352H32.3221V23.384ZM35.4217 25.652C35.4217 24.98 35.5537 24.384 35.8177 23.864C36.0897 23.344 36.4577 22.944 36.9217 22.664C37.3857 22.384 37.9017 22.244 38.4697 22.244C38.9017 22.244 39.3137 22.34 39.7057 22.532C40.0977 22.716 40.4097 22.964 40.6417 23.276V20.12H42.3457V29H40.6417V28.016C40.4337 28.344 40.1417 28.608 39.7657 28.808C39.3897 29.008 38.9537 29.108 38.4577 29.108C37.8977 29.108 37.3857 28.964 36.9217 28.676C36.4577 28.388 36.0897 27.984 35.8177 27.464C35.5537 26.936 35.4217 26.332 35.4217 25.652ZM40.6537 25.676C40.6537 25.268 40.5737 24.92 40.4137 24.632C40.2537 24.336 40.0377 24.112 39.7657 23.96C39.4937 23.8 39.2017 23.72 38.8897 23.72C38.5777 23.72 38.2897 23.796 38.0257 23.948C37.7617 24.1 37.5457 24.324 37.3777 24.62C37.2177 24.908 37.1377 25.252 37.1377 25.652C37.1377 26.052 37.2177 26.404 37.3777 26.708C37.5457 27.004 37.7617 27.232 38.0257 27.392C38.2977 27.552 38.5857 27.632 38.8897 27.632C39.2017 27.632 39.4937 27.556 39.7657 27.404C40.0377 27.244 40.2537 27.02 40.4137 26.732C40.5737 26.436 40.6537 26.084 40.6537 25.676Z",
    fill: "#2A2A2B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_419_4072",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_419_4072"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_419_4072"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleGame2);
export default __webpack_public_path__ + "static/media/Title Game2.66c61d667c77ef79563679ceef3cef6b.svg";
export { ForwardRef as ReactComponent };